// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonLabelBox{
    margin-bottom: 7px;
}

.commonLabelBox_label{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 150%;

    color: #3B4256;
    margin-bottom: 5px;
}   `, "",{"version":3,"sources":["webpack://./src/components/labelBox/LabelBox.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".commonLabelBox{\n    margin-bottom: 7px;\n}\n\n.commonLabelBox_label{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 150%;\n\n    color: #3B4256;\n    margin-bottom: 5px;\n}   "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
